import { Grid2 as Grid, Typography } from "@mui/material";
import TeacherDataTable from "../../_components/TeacherDataTable";

const RecentActivities = () => {
  return (
    <>
      <Grid container spacing={2} justifyContent="space-between" alignItems="center">
        <Typography variant="title">Recent Activities</Typography>

        <TeacherDataTable
          title="resent-activities"
          header={false}
          rows={[]}
          column={["Title", "Type", "Time Spent", "Last Activity"]}
        />
      </Grid>
    </>
  );
};

export default RecentActivities;
